import { css } from "../../../../styled-system/css";

export const styles = {
  modalButton: () =>
    css({
      background: "none",
      border: "none",
      color: "linkBlue",
      fontWeight: 700,
      textDecoration: "underline",
      padding: 0,
      margin: 0,
    }),
  button: () =>
    css({
      marginLeft: 0,
    }),
  inlineModalButton: () =>
    css({
      all: "unset",
      cursor: "pointer",
      color: "inherit",
      textDecoration: "inherit",
      textDecorationStyle: "inherit",
    }),
};
